var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "66.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 66.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 687 l-112 -112 0 -240 c0 -345 -9 -335 320 -335 236 0 266 6 300 62 19 31 20 50 20 338 0 288 -1 307 -20 338 -32 53 -69 62 -242 62 l-153 0 -113 -113z m455 39 l28 -24 0 -302 0 -302 -28 -24 c-28 -24 -30 -24 -247 -24 -217 0 -219 0 -247 24 l-28 24 -3 226 -3 226 80 0 c110 0 121 11 121 120 l0 80 149 0 c144 0 151 -1 178 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 585 l0 -65 70 0 70 0 0 65 0 65 -70 0 -70 0 0 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 418 c0 -16 15 -18 170 -18 155 0 170 2 170 18 0 15 -15 17 -170 17 -155 0 -170 -2 -170 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 305 c0 -13 26 -15 170 -15 144 0 170 2 170 15 0 13 -26 15 -170 15 -144 0 -170 -2 -170 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 195 c0 -13 26 -15 170 -15 144 0 170 2 170 15 0 13 -26 15 -170 15 -144 0 -170 -2 -170 -15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFileIcon);
export default __webpack_public_path__ + "static/media/common_file_icon.d81e1b9607d1e976a0ef8383d0fbd7b6.svg";
export { ForwardRef as ReactComponent };